import type { DecorationImageSrc } from "@/lib/qr-sign-maker/layout";

// Loads a sprig PNG from this site's own public folder for the PDF. It is a
// plain GET of a static file: no cookies, and nothing about the sign is sent.
// A stalled request gives up after 10 seconds and the PDF is made without it.

export async function loadDecorationImage(src: DecorationImageSrc): Promise<Uint8Array> {
  const response = await fetch(src, { credentials: "omit", signal: AbortSignal.timeout(10_000) });
  if (!response.ok) {
    throw new Error(`Decoration image ${src}: HTTP ${response.status}`);
  }
  return new Uint8Array(await response.arrayBuffer());
}
